<template>
	<div>
		<el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>景点管理</el-breadcrumb-item>
			<el-breadcrumb-item>景点列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin: 15px; min-height: calc(100vh - 111px)">
			<div>
				<!--    功能区-->
				<div style="margin: 10px 0">
					<!--    搜索区-->
					<div style="margin: 10px 0">
						<el-input v-model="search" clearable placeholder="请输入景点" prefix-icon="Search"
							style="width: 20%" />
						<el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"></el-button>
						<el-button icon="refresh-left" style="margin-left: 10px" type="default"
							@click="reset"></el-button>
						<div style="float: right">
							<el-tooltip content="添加" placement="top">
								<el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
							</el-tooltip>
						</div>
					</div>
				</div>
				<!--    表格-->
				<el-table v-loading="loading" :data="tableData" border max-height="705" show-overflow-tooltip
					style="width: 100%">
					<el-table-column label="ID" prop="id" width="100px" />
					<el-table-column label="景点名称" prop="className" />
					<el-table-column label="景点介绍" width="400">
						<template #default="scope">
							<div v-if="scope.row.introduction" class="introduction-content">
								<div v-for="(line, index) in formatIntroduction(scope.row.introduction)" :key="index"
									class="introduction-line">
									<span class="line-content">{{ line }}</span>
								</div>
								<el-button v-if="shouldShowMore(scope.row.introduction)" size="small" type="text"
									@click="showFullIntroduction(scope.row.introduction)">
									查看更多...
								</el-button>
							</div>
							<span v-else class="no-introduction">无景点介绍</span>
						</template>
					</el-table-column>
					<el-table-column label="门票价格" prop="price" />
					<el-table-column label="景点图片" prop="pictures">
						<template #default="scope">
							<el-image style="width: 300px; height: 200px" :src="scope.row.pictures"></el-image>
						</template>
					</el-table-column>
					<!-- <el-table-column label="关联酒店" prop="attractions" width="200">
						<template #default="scope">
							<el-tag v-if="scope.row.attractions && scope.row.attractions.length > 0"
								v-for="attraction in scope.row.attractions" :key="attraction.id" style="margin: 2px">
								{{ attraction.name }}
							</el-tag>
							<span v-else style="color: #ccc">暂无关联酒店</span>
						</template>
					</el-table-column> -->


					<!--      操作栏-->
					<el-table-column label="操作" width="130px">
						<template #default="scope">
							<el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
							<el-button icon="Delete" type="danger" @click="handleDelete(scope.row.id)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--分页-->
				<div style="margin: 10px 0">
					<el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]"
						:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<el-dialog v-model="introductionDialogVisible" title="景点介绍详情" width="60%">
					<div class="full-introduction-content">
						<div v-for="(line, index) in formattedFullIntroduction" :key="index" class="introduction-line">
							<span class="line-content">{{ line }}</span>
						</div>
					</div>
				</el-dialog>
				<!--      弹窗-->
				<div>
					<el-dialog v-model="dialogVisible" title="操作" width="70%" @close="cancel">
						<el-form ref="form" :model="form" :rules="rules" label-width="120px">
							<el-form-item label="景点名称" prop="className">
								<el-input v-model="form.className" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="门票价格" prop="price">
								<el-input v-model="form.price" style="width: 80%"></el-input>
							</el-form-item>
							<el-form-item label="景点介绍" prop="introduction">
								<el-input v-model="form.introduction" type="textarea" rows="4" clearable
									style="width:80%" placeholder="请输入景点介绍"></el-input>
							</el-form-item>
							<el-form-item label="景点图片" prop="competitionPictures">
								<el-upload :on-success="uploadSuccess" :show-file-list="false"
									action="http://106.15.41.48:9090/backend/files/upload/" class="upload-demo">
									<div class="AvatarDiv" style="background-color: #c0c4cc;width: 300px;height:300px;">
										<!-- <el-avatar icon="UserFilled" style="width: 80px; height: 80px"></el-avatar> -->
										<img v-if="status ==3" :src="imgurl" style="width: 300px; height: 300px;" />
										<img v-if="status ==2" :src="form.pictures"
											style="width: 300px; height: 300px;" />
										<div class="editImg">
											更换图片
											<el-icon color="color">
												<edit></edit>
											</el-icon>
										</div>
									</div>
								</el-upload>
							</el-form-item>
							<!-- <el-form-item label="关联酒店" prop="attractionIds">
								<el-select v-model="form.attractionIds" multiple placeholder="请选择关联酒店"
									style="width: 50%">
									<el-option v-for="item in attractionsList" :key="item.id" :label="item.name"
										:value="item.id" />
								</el-select>
							</el-form-item> -->

						</el-form>
						<template #footer>
							<span class="dialog-footer">
								<el-button @click="cancel">取 消</el-button>
								<el-button type="primary" @click="save">确 定</el-button>
							</span>
						</template>
					</el-dialog>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
	import request from "@/utils/request";

	const {
		ElMessage
	} = require("element-plus");

	export default {
		name: "BuildingInfo",
		components: {},
		data() {
			return {
				loading: true,
				disabled: false,
				judge: false,
				status: 0,
				dialogVisible: false,
				search: "",
				currentPage: 1,
				pageSize: 10,
				total: 0,
				filename: "",
				imgurl: "",
				tableData: [],
				fileSelected: false,
				attractionsList: [],
				introductionDialogVisible: false, // 新增：景点介绍详情弹窗
				fullIntroduction: "", // 新增：完整的景点介绍
				formattedFullIntroduction: [], // 新增：格式化后的完整景点介绍
				form: {
					className: "",
					price: "",
					introduction: "",
					pictures: "",
					attractionIds: []
				},
				rules: {
					className: [{
						required: true,
						message: '请输入景点名称',
						trigger: 'change'
					}],
					introduction: [{
						required: true,
						message: '请输入景点介绍',
						trigger: 'change'
					}],
					price: [{
						required: true,
						message: '请输入景点门票价格',
						trigger: 'change'
					}]
				},

			};
		},
		created() {
			this.load();
			this.loadAttractions();
			this.loading = true;
			setTimeout(() => {
				//设置延迟执行
				this.loading = false;
			}, 1000);
			// this.init(this.avatar);
		},
		methods: {
			formatIntroduction(introduction) {
			      if (!introduction) return [];
			      const lines = introduction.split('\n').filter(line => line.trim() !== '');
			      // 只返回前3行，避免表格行过高
			      return lines.slice(0, 3);
			    },
			    
			    // 判断是否应该显示"查看更多"按钮
			    shouldShowMore(introduction) {
			      if (!introduction) return false;
			      const lines = introduction.split('\n').filter(line => line.trim() !== '');
			      return lines.length > 3;
			    },
			    
			    // 显示完整的景点介绍
			    showFullIntroduction(introduction) {
			      this.fullIntroduction = introduction;
			      this.formattedFullIntroduction = introduction.split('\n').filter(line => line.trim() !== '');
			      this.introductionDialogVisible = true;
			    },
			async load() {
				request.get("/publicize/find", {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log(res);
					this.tableData = res.data.records;
					this.avatar = res.data.records.picture;
					console.log(this.avatar)
					this.total = res.data.total;
					this.loading = false;
				});
			},
			async loadAttractions() {
				request.get("/signup/find", {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize,
						search: this.search,
					},
				}).then((res) => {
					console.log("景点列表", res);
					this.attractionsList = res.data.records;
				});
			},
			fileChange(uploadFile, fileList) {
				this.form.picture = uploadFile

				if (fileList.length !== 0) {
					this.$refs.form.validateField('picture')
				}
			},
			filterTag(value, row) {
				return row.dormBuildDetail === value;
			},
			uploadSuccess(response) {
				this.imgurl = "http://106.15.41.48:9090/images/" + response.data;
				this.filename = response.data
				this.status = 3;
				console.log(this.filename)
				console.log(this.imgurl)
			},
			add() {
				this.status = 1;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					this.disabled = false;
					this.form = {};
					this.judge = false;
				});
			},

			save() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (this.judge === false) {
							this.form.pictures = "http://106.15.41.48:9090/images/" + this.filename
							const requestData = {
								...this.form
							};
							if (Array.isArray(requestData.attractionIds)) {
								requestData.attractionIds = requestData.attractionIds.join(',');
							}
							request.post("/publicize/add", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "新增成功",
										type: "success",
									});
									this.search = "";
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						} else {
							if (this.status == 3) {
								this.form.pictures = "http://106.15.41.48:9090/images/" + this.filename
							}
							const requestData = {
								...this.form
							};
							if (Array.isArray(requestData.attractionIds)) {
								requestData.attractionIds = requestData.attractionIds.join(',');
							}
							request.put("/publicize/update", requestData).then((res) => {
								console.log(res);
								if (res.code === "0") {
									ElMessage({
										message: "修改成功",
										type: "success",
									});
									this.search = "";
									this.load();
									this.dialogVisible = false;
								} else {
									ElMessage({
										message: res.msg,
										type: "error",
									});
								}
							});
						}
					}
				});
			},
			cancel() {
				this.$refs.form.resetFields();
				this.dialogVisible = false;
			},
			handleEdit(row) {
				//修改
				this.status = 2;
				this.judge = true;
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					// 生拷贝
					this.form = JSON.parse(JSON.stringify(row));
					if (this.form.attractionIds && typeof this.form.attractionIds === 'string') {
						// 如果后端返回的是字符串格式，转换为数组
						this.form.attractionIds = this.form.attractionIds.split(',').map(id => parseInt(id));
					} else if (!this.form.attractionIds) {
						// 如果没有景点ID数据，初始化为空数组
						this.form.attractionIds = [];
					}
					this.disabled = true;
				});
			},
			handleDelete(id) {
				console.log(id);
				request.delete("/publicize/delete/" + id).then((res) => {
					if (res.code === "0") {
						ElMessage({
							message: "删除成功",
							type: "success",
						});
						this.search = "";
						this.load();
					} else {
						ElMessage({
							message: res.msg,
							type: "error",
						});
					}
				});
			},
			handleSizeChange(pageSize) {
				//改变每页个数
				this.pageSize = pageSize;
				this.load();
			},
			handleCurrentChange(pageNum) {
				//改变页码
				this.currentPage = pageNum;
				this.load();
			},
		},
	};
</script>
<style scoped>
	.introduction-content {
	    max-height: 200px;
	    overflow: hidden;
	  }
	  
	  .introduction-line {
	    margin-bottom: 4px;
	    line-height: 1.4;
	    font-size: 13px;
	    position: relative;
	    padding-left: 12px;
	  }
	  
	  .line-content {
	    word-break: break-all;
	  }
	  
	  .no-introduction {
	    color: #909399;
	    font-style: italic;
	  }
	  
	  .full-introduction-content {
	    max-height: 60vh;
	    overflow-y: auto;
	    padding-right: 10px;
	  }
	  
	  .full-introduction-content .introduction-line {
	    margin-bottom: 6px;
	    padding-bottom: 6px;
	    border-bottom: 1px dashed #eee;
	  }
	@import '../assets/css/RoomInfo.css';
</style>